<template>
	<div class="orderList">
		<div class="search">
			<div class="search-l">
				<div class="l-item" style="width: 40%;">
					<div class="item-label">直播时间:</div>
					<div class="item-input" style="width: 80%;">
						<el-date-picker v-model="dateVal" type="datetimerange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" style="width: 100%;">
						</el-date-picker>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">状态:</div>
					<div class="item-input">
						<el-select v-model="searchForm.status" placeholder="请选择状态">
							<el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<el-button type="warning"
						@click.stop="loading = true, page = 1, searchForm.begin = dateVal[0], searchForm.end = dateVal[1], getList()">搜索</el-button>
					<el-button
						@click.stop="loading = true, page = 1, pageNum = 10, searchForm = {}, searchForm.begin = dateVal[0], searchForm.end = dateVal[1], getList()">重置</el-button>
				</div>
				<i></i>
				<i></i>
				<i></i>
				<i></i>
			</div>
		</div>
		<div class="table">
			<div class="table-operation">
				<el-button type="info" icon="el-icon-refresh-left" @click.stop="loading = true, getList()"></el-button>
			</div>
			<Table :data="tableData" :total="total" v-loading="loading"
				@size-change="pageNum = $event, loading = true, getList()"
				@current-change="page = $event, loading = true, getList()" style="width: 100%" border
				:header-cell-style="{
				background: '#f5f7fa',
				fontWeight: 'bold',
				color: '#303133'
			}">
				<el-table-column label="ID" prop="id" align="center"></el-table-column>
				<el-table-column label="封面" align="center">
					<template slot-scope="scope">
						<el-image style="width: 50px; height: 40px" :src="scope.row.cover"
							:preview-src-list="[scope.row.cover]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="标题" prop="title" align="center"></el-table-column>
				<el-table-column label="开始时间" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.start_at }}</span>
					</template>
				</el-table-column>
				<el-table-column label="结束时间" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.end_at }}</span>
					</template>
				</el-table-column>

				<el-table-column label="状态" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0" type="normal">未开始</span>
						<span v-if="scope.row.status == 1" type="success">进行中</span>
						<span v-if="scope.row.status == 2" type="danger">已结束</span>
					</template>
				</el-table-column>
				<el-table-column label="最高在线" prop="user_count" align="center"></el-table-column>
				<el-table-column label="观看人次" prop="view_count" align="center"></el-table-column>
				<el-table-column label="分销" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.is_distribution == 1" type="success">开启</span>
						<span v-else>关闭</span>
					</template>
				</el-table-column>
				<el-table-column label="到店付" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.enable_offline_pay == 0">关闭</span>
						<span v-else type="success">开启</span>
					</template>
				</el-table-column>
				<el-table-column label="退款(分钟)" prop="refund_minutes" align="center">
				</el-table-column>
				<el-table-column label="最大带宽(MB)" prop="band_width" align="center"></el-table-column>
				<el-table-column label="流量(MB)" prop="flux" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button type="success" size="mini" @click.stop="handleShare(scope.row)">开启分享</el-button>
						<el-button type="primary" size="mini" @click.stop="handleDetail(scope.row)">详情</el-button>
					</template>
				</el-table-column>
			</Table>
		</div>
		<el-dialog :title="roomTitle+'的详情'" :visible.sync="dialogVisible" :close-on-click-modal="false" v-el-drag-dialog
			width="80%" @close="closeRecordDialog">
			<div class="summary-dialog">
				<el-tabs v-model="activeName" @tab-click="handleTabClick">
					<el-tab-pane :label="'商品详情(预估采购￥'+detailData.total+')'" name="goods">
						<el-table :data="goodsTableData" v-loading="loading" style="width: 100%" border height="600"
							:header-cell-style="{
							background: '#f5f7fa',
							fontWeight: 'bold',
							color: '#303133'
						}">
							<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
							<el-table-column label="到货类型" prop="arrived_type_text" align="center"></el-table-column>
							<el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
							<el-table-column label="商品主图" align="center">
								<template slot-scope="scope">
									<el-image style="width: 50px; height: 50px" :src="scope.row.goods_thumb"
										:preview-src-list="[scope.row.goods_thumb]">
									</el-image>
								</template>
							</el-table-column>
							<el-table-column label="直播库存" prop="stock" align="center"></el-table-column>
							<el-table-column label="直播销量" prop="sale_num" sortable="" align="center"></el-table-column>
							<el-table-column label="直播售价" prop="guide_price" align="center"></el-table-column>
							<el-table-column label="团长采购" prop="price" align="center"></el-table-column>
							<el-table-column prop="cost" label="我的成本" align="center"></el-table-column>
							<el-table-column label="限购数量" prop="stock" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.quota > 0">{{scope.row.quota}}</span>
									<span v-else>不限</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center" width="360" v-if="roomStatus == 1">
								<template slot-scope="scope">
									<el-button type="danger" size="mini"
										@click.stop="handleSale(scope.row)">销量</el-button>
									<el-button type="primary" size="mini"
										@click.stop="handleStock(scope.row)">库存</el-button>
									<el-button type="success" size="mini"
										@click.stop="handlePrice(scope.row)">售价</el-button>
									<el-button size="mini" @click.stop="handleQuota(scope.row)">限购</el-button>
									<el-button type="warning" size="mini"
										@click.stop="operationFn(scope.row)">讲解</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane :label="'团长详情(销售￥'+detailData.leader_total+')'" name="leader">
						<el-table :data="leaderTableData" v-loading="loading" style="width: 100%" border height="600"
							:header-cell-style="{
							background: '#f5f7fa',
							fontWeight: 'bold',
							color: '#303133'
						}">
							<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
							<el-table-column prop="title" label="团长信息" align="center"></el-table-column>
							<el-table-column prop="personCount" label="下单人数" align="center"></el-table-column>
							</el-table-column>
							<el-table-column prop="orderCount" label="订单数" align="center"></el-table-column>
							</el-table-column>
							<el-table-column prop="total" label="销售额" align="center"></el-table-column>
							</el-table-column>
							<el-table-column label="操作" align="center" width="360">
								<template slot-scope="scope">
									<el-button type="primary" size="mini"
										@click.stop="handleGoodsDetail(scope.row)">商品详细</el-button>
										<el-button type="success" size="mini"
											@click.stop="handleLeaderShare(scope.row)">分享链接</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane :label="'团长商品详情('+tmpLeader+')'" name="leaderGoods">
						<el-table :data="leaderGoodsTableData" style="width: 100%" border height="600"
							:header-cell-style="{
							background: '#f5f7fa',
							fontWeight: 'bold',
							color: '#303133'
						}">
							<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
							<el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
							<el-table-column prop="count" label="销量" align="center"></el-table-column>
							<el-table-column prop="amount" label="销售额" align="center"></el-table-column>
							</el-table-column>

						</el-table>
					</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="handleRefresh">刷新</el-button>
				<el-button type="success" @click.stop="handleExport(1)"
					v-loading.fullscreen.lock="loading">导出商品详情</el-button>
				<el-button type="success" @click.stop="handleExport(2)"
					v-loading.fullscreen.lock="loading">导出团长明细</el-button>
				<el-button type="info" @click.stop="closeRecordDialog">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="请复制下方链接到微信打开" :visible.sync="dialogShareVisible" :close-on-click-modal="false"
			v-el-drag-dialog width="30%">
			<el-form ref="form" label-width="100px">
				<el-form-item label="微信链接：">
					<el-input type="textarea" rows="5" placeholder="" v-model="shortLink" readonly=""></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="dialogShareVisible = false">关 闭</el-button>
				<el-button type="warning" @click.stop="copyFn()">复制并关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dateVal: [],
				searchForm: {
					begin: '',
					end: '',
				},
				// 状态
				statusOptions: [{
						id: 0,
						name: '未开始'
					},
					{
						id: 1,
						name: '进行中'
					},
					{
						id: 2,
						name: '已结束'
					}
				],
				tableData: [],
				detailData: {},
				loading: true,
				page: 1,
				pageNum: 10,
				total: 0,
				pageSizes: [10, 50, 200, 1000],
				// 弹窗
				dialogVisible: false,
				roomTitle: "",
				roomStatus: 0,
				roomId: 0,
				activeName: "goods",
				goodsTableData: [],
				leaderTableData: [],
				leaderGoodsTableData: [],
				tmpLeader: "未选择团长",
				dialogShareVisible:false
			}
		},
		mounted() {
			// 时间
			this.dateVal = [this.getCurrentMonthStartDate() + ' ' + '00:00:00', this.getCurrentDate() + ' ' + '23:59:59']
			this.searchForm.begin = this.dateVal[0]
			this.searchForm.end = this.dateVal[1]
			// 列表
			this.getList()
		},
		methods: {
			copyFn() {
				var input = document.createElement('input');
				input.value = this.shortLink; // 将文本赋值给临时输入框
				document.body.appendChild(input); // 将输入框添加到页面中
				input.select(); // 选中输入框的内容
				document.execCommand('copy'); // 执行复制操作
				document.body.removeChild(input); // 移除临时输入框
				this.$message.success('成功复制到剪贴板'); // 提示复制成功
				this.dialogShareVisible = false
			},
			handleLeaderShare(item) {
				this.$http.post(`/erp/v1/live/getLeaderShareLink`, {
					room_id: item.stream_room_id,
					leader_member_id:item.leader_member_id
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.dialogShareVisible = true
						this.shortLink = data.shareLink
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleSale(item){
				this.$prompt('请输入要增加的数量', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^\d+$/,
					inputErrorMessage: '数字格式不正确'
				}).then(({
					value
				}) => {
					this.loading = true
					this.$http.post(`/erp/v1/live/addSale`, {
						room_goods_id: item.id,
						num: value,
					}).then((res) => {
						this.loading = false
						const {
							code,
							msg
						} = res.data
						if (code == 200) {
							this.$message.success(msg);
							//this.getDetail(item.stream_room_id)
							item.sale_num = Number(item.sale_num) + Number(value)
							item.stock -= value
						} else {
							this.$message.error(msg);
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			handleGoodsDetail(leader) {
				//切换tab页
				this.tmpLeader = leader.leader_base_info.username + '[' + leader.leader_cert_info.name + ']'
				this.activeName = "leaderGoods"
				this.leaderGoodsTableData = leader.goodsList
			},
			getList() {
				this.$http.post(`/erp/v1/live/roomLst`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.tableData = data.rows
						this.total = data.total

					} else {
						this.$message.error(msg);
					}
				});
			},
			handleShare(item) {
				this.$http.post(`/erp/v1/live/openShare`, {
					room_id: item.id
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.$message.success("设置成功");
					} else {
						this.$message.error(msg);
					}
				});
			},
			getDetail(roomId) {
				this.loading = true
				this.$http.post(`/erp/v1/live/roomDetail`, {
					room_id: roomId
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.dialogVisible = true
						this.detailData = data
						this.goodsTableData = data.goodsList
						this.leaderTableData = data.leaderList
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleRefresh() {
				this.getDetail(this.roomId)
			},
			// 获取当前年月日
			getCurrentDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 获取当前年月第一日
			getCurrentMonthStartDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = '01';
				return `${year}-${month}-${day}`;
			},
			handleDetail(item) {
				this.roomId = item.id
				this.roomTitle = item.title
				this.roomStatus = item.status
				this.getDetail(item.id)
			},
			// 推送
			operationFn(goodsItem) {
				let that = this
				that.$http.post('/erp/v1/live/pushGoods', {
					room_goods_id: goodsItem.id
				}).then((res) => {
					that.loading = false
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						that.$message.success("推送成功");
					} else {
						that.$message.error(msg);
					}
				});
			},
			closeRecordDialog() {
				this.dialogVisible = false
			},
			handleTabClick(tab, event) {
				this.activeName = tab.name
			},
			handleStock(item) {
				this.$prompt('请输入可售库存数', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^\d+$/,
					inputErrorMessage: '数字格式不正确'
				}).then(({
					value
				}) => {
					this.loading = true
					this.$http.post(`/erp/v1/live/modifyGoods`, {
						room_goods_id: item.id,
						stock: value,
					}).then((res) => {
						this.loading = false
						const {
							code,
							msg
						} = res.data
						if (code == 200) {
							this.$message.success(msg);
							//this.getDetail(item.stream_room_id)
							item.stock = value
						} else {
							this.$message.error(msg);
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			handlePrice(item) {
				this.$prompt('请输入零售价', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^\d+(\.\d{1,2})?$/,
					inputErrorMessage: '数字格式不正确'
				}).then(({
					value
				}) => {
					this.loading = true
					this.$http.post(`/erp/v1/live/modifyGoods`, {
						room_goods_id: item.id,
						price: value,
					}).then((res) => {
						this.loading = false
						const {
							code,
							msg
						} = res.data
						if (code == 200) {
							this.$message.success(msg);
							//this.getDetail(item.stream_room_id)
							item.guide_price = value
						} else {
							this.$message.error(msg);
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			handleQuota(item) {
				this.$prompt('请输入限购数量,输入0代表不限购', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^\d+$/,
					inputErrorMessage: '数字格式不正确'
				}).then(({
					value
				}) => {
					this.loading = true
					this.$http.post(`/erp/v1/live/modifyGoods`, {
						room_goods_id: item.id,
						quota: value,
					}).then((res) => {
						this.loading = false
						const {
							code,
							msg
						} = res.data
						if (code == 200) {
							this.$message.success(msg);
							this.getDetail(item.stream_room_id)
						} else {
							this.$message.error(msg);
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			// 导出商品销售明细
			handleExport(type) {
				this.loading = true
				this.$http.post(`/erp/v1/live/exportGoods`, {
					room_id: this.roomId,
					type: type
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url)
					} else {
						this.$message.error(msg);
					}
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.export-template {
		#template-title {
			.title-t {
				text-align: center;
				margin-bottom: 20px;
				font-weight: bold;
				font-size: 22px;

			}

			.title-box {
				display: flex;
				flex-wrap: wrap;

				.box-item {
					width: 50%;
					display: flex;
					justify-content: center;
					margin-bottom: 20px;

					.item-i {
						width: 60%;

						span {
							padding-right: 20px;
						}
					}
				}
			}
		}
	}

	.page {
		margin-top: 20px;
		text-align: right;
	}
</style>